'use client'

import { EPageType, ETrackingEvent } from '@/lib/gtm/type'
import { useEffect } from 'react'

type DataLayerEvent = {
  page_type?: EPageType
  event?: ETrackingEvent
  page_category?: string
  page_category2?: string
} & Record<string, unknown>

export function usePushToDataLayer<T extends DataLayerEvent>(data: T | null) {
  useEffect(() => {
    if (!data) return

    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(data)
    }
  }, [data])
}
